
/**
 * Module dependencies.
 */

import { Text } from './typography';
import { color, media } from 'react-components/styles';
import styled from 'styled-components';

/**
 * Color themes.
 */

const colorThemes = {
  danger: {
    border: color('danger400'),
    label: color('danger')
  },
  default: {
    border: color('gray400'),
    label: color('gray')
  },
  info: {
    border: color('blue400'),
    label: color('primary')
  },
  success: {
    border: color('success300'),
    label: color('success')
  },
  warning: {
    border: color('warning400'),
    label: color('warning')
  }
};

/**
 * Export `StatusLabelColorTheme` type.
 */

export type StatusLabelColorTheme = keyof typeof colorThemes;

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  colorTheme: StatusLabelColorTheme;
  label: string;
};

/**
 * `StatusWrapper` styled component.
 */

const StatusWrapper = styled.div<{ colorTheme: StatusLabelColorTheme }>`
  align-items: center;
  border: 1px solid ${({ colorTheme }) => colorThemes[colorTheme].border};
  border-radius: 8px;
  display: flex;
  padding: 1px 5px;

  ${media.min('sm')`
    padding: 3px 5px;
  `}
`;

/**
 * `Label` styled component.
 */

const Label = styled(Text).attrs({ size: 'small' })<{ colorTheme: StatusLabelColorTheme }>`
  color: ${({ colorTheme }) => colorThemes[colorTheme].label};
`;

/**
 * Export `StatusLabel` component.
 */

export function StatusLabel(props: Props): JSX.Element {
  const { className, colorTheme, label } = props;

  return (
    <StatusWrapper
      className={className}
      colorTheme={colorTheme}
    >
      <Label colorTheme={colorTheme}>
        {label}
      </Label>
    </StatusWrapper>
  );
}
